import { agreeToTermsOfService, getTermsOfServiceStatus } from '../../api/taxiTrip';

export interface TermsOfServiceContent {
  tosId: number;
  contents: string;
}

export interface TermsOfServiceStatus {
  needsAgreement: boolean;
  content: TermsOfServiceContent | null;
}

export const fetchTermsOfServiceStatus = async (): Promise<TermsOfServiceStatus> => {
  const { data } = await getTermsOfServiceStatus();

  if (data.isUserChecked) {
    return { content: null, needsAgreement: false };
  }

  return {
    content: {
      tosId: data.tosId,
      contents: data.tosContents,
    },
    needsAgreement: true,
  };
};

export const submitTermsOfServiceAgreement = async (tosId: number): Promise<void> => {
  await agreeToTermsOfService(tosId);
};
